export const WHATSAPP_NUMBER = "5582991163764";
export const WHATSAPP_DISPLAY = "(82) 99116-3764";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const getWaNumber = () =>
    (typeof window !== "undefined" && window.__CONBOX_WA) || WHATSAPP_NUMBER;

export const waLink = (message) =>
    `https://wa.me/${getWaNumber()}?text=${encodeURIComponent(message)}`;

export const waOpen = (message) => {
    window.open(waLink(message), "_blank", "noopener,noreferrer");
};

export const DEFAULT_MSG =
    "Olá! Gostaria de receber uma apresentação e solicitar a implantação do minimercado autônomo Conbox no meu condomínio.";

export const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -64 });
    else el.scrollIntoView({ behavior: "smooth" });
};

export const IMAGES = {
    lojaNoite: "/img/loja-noite.jpg",
    lojaConteiner: "/img/loja-conteiner.jpg",
    heroContainer: "/img/loja-conteiner.jpg",
    containerDay:
        "https://static.prod-images.emergentagent.com/jobs/5be95d2a-9b39-4830-bb13-e02ff39b0057/images/828d958fadcfae9e9822035555847a48289adccacdb59c9c62dd666c9713f928.jpeg",
    interiorGondolas:
        "https://static.prod-images.emergentagent.com/jobs/5be95d2a-9b39-4830-bb13-e02ff39b0057/images/cf3614ef98d378b3a04903281ef28e36e0cf6ec83baf44a0058e0057e8b9551d.jpeg",
    phoneQr:
        "https://static.prod-images.emergentagent.com/jobs/5be95d2a-9b39-4830-bb13-e02ff39b0057/images/81638b43ffb8309dc63d686bbb8ed22ca863e669bff26683ee52a05b54ad8676.jpeg",
    autoatendimento:
        "https://static.prod-images.emergentagent.com/jobs/5be95d2a-9b39-4830-bb13-e02ff39b0057/images/ef29ad253f22337de4167f0081fd9743e0fc6e699dd1423dd294ef3633413037.jpeg",
};
